<template>
    <div id="app">
        <transition :name="transitionName">
            <tab-bar-content></tab-bar-content>
        </transition>
    </div>
</template>

<script>
    import TabBarContent from "@/components/content/tabbar/TabBarContent";
    export default {
        name: 'App',
        data(){
            return{
                transitionName: 'fold-left'
            }
        },
        components: {
            TabBarContent: TabBarContent,
        },
        metaInfo: {
            title: '啊购购云商城',
            meta: [
                {charset: 'utf-8'},
                {
                    name: 'viewport',
                    content: 'width=device-width, initial-scale=1.0, user-scalable=no'
                }
            ]
        },

    }
</script>

<style>
    @import "~@/assets/css/common/style.css";
    html,body,#app {
        position: fixed;
        width: 100%;
        height: 100%;
        background-color: #f8f6f7;
        margin: 0;
        padding: 0;
        overflow: auto;
    }

    .fold-left-enter-active {
        animation-name: fold-left-in;
        animation-duration: .3s;
    }
    .fold-left-leave-active {
        animation-name: fold-left-out;
        animation-duration: .3s;
    }
    @keyframes fold-left-in {
        0% {
            -webkit-transform: translate3d(100%, 0, 0);
            transform: translate3d(100%, 0, 0);
            /* visibility: visible; */
        }
        /*50% {
          transform: translate3d(50%, 0, 0);
        }*/
        100% {
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }
    }
    @keyframes fold-left-out {
        0% {
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }
        /*50% {
          transform: translate3d(-50%, 0 , 0);
        }*/
        100% {
            -webkit-transform: translate3d(-100%, 0, 0);
            transform: translate3d(-100%, 0, 0);
            /* visibility: hidden; */
        }
    }
    .fold-right-enter-active {
        animation-name: fold-right-in;
        animation-duration: .3s;
    }
    .fold-right-leave-active {
        animation-name: fold-right-out;
        animation-duration: .3s;
    }
    @keyframes fold-right-in{
        0% {
            width: 100%;
            -webkit-transform: translate3d(-100%, 0, 0);
            transform: translate3d(-100%, 0, 0);
            /* visibility: visible; */
        }
        /*50% {
          transform: translate3d(50%, 0, 0);
        }*/
        100% {
            width: 100%;
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }
    }
    @keyframes fold-right-out  {
        0% {
            width: 100%;
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }
        /*50% {
          transform: translate3d(-50%, 0 , 0);
        }*/
        100% {
            width: 100%;
            -webkit-transform: translate3d(100%, 0, 0);
            transform: translate3d(100%, 0, 0);
            /* visibility: hidden; */
        }
    }
</style>
